import { CosmosDb } from '../cosmosDb.js';

export namespace SnippetDb {
	export const snippetCategories = ['CooldownInstruction', 'WarmupInstruction', 'Misc'] as const;

	export type SnippetCategory = (typeof snippetCategories)[number];

	export interface ISnippetItem extends CosmosDb.ItemDefaultOmit<IBaseSnippetItem>, CosmosDb.ICosmosItem {}

	export interface IBaseSnippetItem extends CosmosDb.IBaseItem {
		readonly text: string;
		readonly category: SnippetCategory;
	}

	export interface ISnippetIdProps {}
}
